<div class="idle-dialog-container">
  <h2 mat-dialog-title class="title global-h2">
    <mat-icon class="warning-icon" color="warn">hourglass_empty</mat-icon>
    Session Expiring Soon
  </h2>

  <mat-dialog-content class="content">
    <p class="global-p">Your session will expire in</p>

    <div class="countdown">
      {{ data.seconds }}s
    </div>

    <p class="global-p">Please continue to stay signed in.</p>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="actions">
    <button mat-raised-button color="primary" class="continue-btn global-button" (click)="close()">
      Continue Session
    </button>
  </mat-dialog-actions>
</div>
